import { errors as codes } from "@chaser/codes";
import ApiError from "./ApiError";
import { formatFileSize } from ".";
import BillingError from "./BillingError";
import TotpRequiredError from "./TotpRequiredError";

const errors = {
  [codes.ATTACHMENT_UPLOAD_FAILED]: "File failed to upload, please try again.",
  [codes.FILETYPE_NOT_VALID]:
    "File failed to upload, because it's type is not allowed.",
  [codes.ATTACHMENT_TOO_BIG]: (meta) =>
    `Combined attachments size exceeds ${formatFileSize(meta.allowed)} ${
      meta.fixed
        ? `this includes ${formatFileSize(meta.fixed)} for the attached invoices/statement`
        : ""
    }`,
  [codes.INVITE_FAILED_MAX_USERS]:
    "Reached your plan's maximum number of users",
  [codes.INVITE_FAILED_USER_ADDED]: "User already belongs to organisation.",
  [codes.INVITE_FAILED_USER_INVITED]: "User was already invited.",
  [codes.CURRENCY_NOT_SUPPORTED]:
    "Your currency is currently not supported for billing through the Xero App Store. Please reach out to Chaser's team directly for support and/or alternative billing options.",
  [codes.INVITE_FAILED_TRY_LATER]: (meta) =>
    meta?.timeLeft
      ? `Please wait ${meta.timeLeft} seconds before inviting another user.`
      : "Try again later.",
  [codes.SAGE200_INSUFFICIENT_PERMISSIONS]:
    "Chaser connected to Sage 200, but your user account lacks API permissions. Please contact your Sage 200 admin to request access.",
  resource_not_found:
    "The requested resource could not be found. It may have been moved or deleted.",
};

function getErrorMessage(err, fallback = "Something went wrong.") {
  if (navigator.onLine === false) return "You appear to be offline.";
  if (err.code && errors[err.code]) {
    const m = errors[err.code];
    return typeof m === "function" ? m(err.meta) : m;
  }
  if (err instanceof TotpRequiredError)
    return "Two-Factor Authentication (2FA) is required for all Chaser users";
  if (err instanceof BillingError)
    return "Something went wrong with our billing system.";

  if (err instanceof ApiError && err.message) {
    const message = err.message;

    if (
      message.includes('"type":"invalid_request"') &&
      message.includes('"error_code":"resource_not_found"')
    ) {
      return (
        errors["resource_not_found"] ||
        "The requested resource could not be found."
      );
    }

    if (message.includes('"http_status_code":404')) {
      return "The requested page or resource could not be found.";
    }

    if (message.length > 200) {
      const errorCodeMatch = message.match(/"error_code":"([^"]+)"/);
      if (errorCodeMatch && errors[errorCodeMatch[1]]) {
        return errors[errorCodeMatch[1]];
      }
      const simpleMessageMatch = message.match(/"message":"([^"]+)"/);
      if (simpleMessageMatch) {
        return simpleMessageMatch[1];
      }

      return "An unexpected error occurred. Please try again or contact support if the problem persists.";
    }

    return message;
  }

  return fallback;
}

export { getErrorMessage, errors };
